(function () {
var CLE = 'meyorie-carte-du-jour';
function melanger(t) {
t = t.slice();
for (var i = t.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = t[i]; t[i] = t[j]; t[j] = x; }
return t;
}
function aujourdhui() { var d = new Date(); return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate(); }
function lire() { try { var v = JSON.parse(localStorage.getItem(CLE) || 'null'); return v && v.jour === aujourdhui() ? v.numero : null; } catch (e) { return null; } }
function garder(numero) { try { localStorage.setItem(CLE, JSON.stringify({ jour: aujourdhui(), numero: numero })); } catch (e) {} }
function init(section) {
if (section.dataset.mPret) return;
section.dataset.mPret = '1';
var cartes = Array.prototype.map.call(section.querySelectorAll('.m-carte-donnee'), function (el) { return el.dataset; });
var grille = section.querySelector('.m-tirage');
var voile = section.querySelector('.m-voile');
var carte = section.querySelector('.m-carte');
if (!grille || !voile || !carte || !cartes.length) return;
var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var dernierDos = null, occupe = false;
function q(sel) { return section.querySelector(sel); }
function dessiner() {
grille.innerHTML = '';
grille.classList.remove('is-choix');
melanger(cartes).forEach(function (c, i) {
var b = document.createElement('button');
b.type = 'button'; b.className = 'm-dos';
b.style.setProperty('--i', i);
b.style.setProperty('--r', (Math.random() * 7 - 3.5).toFixed(1) + 'deg');
b.style.setProperty('--y', (Math.random() * 10 - 5).toFixed(0) + 'px');
b.setAttribute('aria-label', 'Carte ' + (i + 1) + ', face cachée');
b.innerHTML = '<span class="m-dos__medaillon"><span class="m-enso"></span></span>';
b.addEventListener('click', function () { choisir(b, c); });
grille.appendChild(b);
});
}
function choisir(b, c) {
if (occupe) return;
occupe = true; dernierDos = b;
grille.classList.add('is-choix');
b.classList.add('is-choisie');
garder(c.numero);
setTimeout(function () { ouvrir(c); occupe = false; }, reduit ? 0 : 520);
}
function ouvrir(c) {
q('.m-face__img').style.backgroundImage = 'url(' + c.image + ')';
q('.m-face__img').style.backgroundPosition = c.position || '50% 55%';
q('.m-face__num').textContent = c.numero || '';
q('.m-face__sit').textContent = c.situation || '';
q('.m-face__kj').textContent = c.kanji || '';
q('.m-face__rm').textContent = c.romaji || '';
q('.m-face__sens').textContent = c.sens ? '« ' + c.sens + ' »' : '';
q('.m-face__geste-txt').textContent = c.geste || '';
voile.hidden = false;
document.body.style.overflow = 'hidden';
carte.classList.remove('is-ouverte');
if (reduit) { carte.classList.add('is-ouverte'); }
else { requestAnimationFrame(function () { requestAnimationFrame(function () { carte.classList.add('is-ouverte'); }); }); }
q('.m-fermer').focus({ preventScroll: true });
montrerDeja();
}
function fermer() {
voile.hidden = true;
document.body.style.overflow = '';
grille.classList.remove('is-choix');
var choisie = grille.querySelector('.is-choisie');
if (choisie) choisie.classList.remove('is-choisie');
if (dernierDos) dernierDos.focus({ preventScroll: true });
}
function nouveauTirage() {
fermer();
if (reduit) { dessiner(); return; }
grille.classList.add('is-rassemble');
setTimeout(function () { grille.classList.remove('is-rassemble'); dessiner(); }, 380);
}
function montrerDeja() {
var deja = q('.m-deja'); if (!deja) return;
var n = lire();
var c = n && cartes.filter(function (x) { return x.numero === n; })[0];
deja.hidden = !c;
if (c) deja.querySelector('.m-deja__revoir').onclick = function () { dernierDos = this; ouvrir(c); };
}
q('.m-fermer').addEventListener('click', fermer);
q('.m-face__livre').addEventListener('click', fermer);
q('.m-face__autre').addEventListener('click', function () {
nouveauTirage();
grille.scrollIntoView({ behavior: reduit ? 'auto' : 'smooth', block: 'center' });
});
var melangeur = q('.m-melanger');
if (melangeur) melangeur.addEventListener('click', nouveauTirage);
voile.addEventListener('click', function (e) { if (e.target === voile) fermer(); });
document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !voile.hidden) fermer(); });
dessiner();
montrerDeja();
}
function tout() { document.querySelectorAll('[data-m-tirage]').forEach(init); }
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
document.addEventListener('shopify:section:load', function (e) { var s = e.target.querySelector('[data-m-tirage]'); if (s) init(s); });
})();
